import PossibilityIndicator from "@/components/possibility-indicator.tsx";
import RadioInput from "@/components/ui/radio-input.tsx";
import ChoiceTooltip from "@/features/sub-families/components/choice-tooltip.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import type { FilterProps } from "./index.tsx";

export default function Radios({ choices, configCode, onClick }: FilterProps) {
    const t = useTranslations();

    return (
        <div className="filters--radios">
            {choices.map((choice) => {
                const checked = configCode === choice.configCode;

                return (
                    <RadioInput
                        key={choice.value}
                        name={choice.value}
                        value={choice.configCode || ""}
                        checked={checked}
                        onChange={() => onClick(choice.configCode || null, choice.isPossible)}
                        variant="withIcon"
                    >
                        {t(choice.label)}
                        <ChoiceTooltip label={choice.label} tooltip={choice.tooltip} image={choice.image} />
                        {!choice.isPossible && <PossibilityIndicator />}
                    </RadioInput>
                );
            })}
        </div>
    );
}
